/**
 * Montaje del SPA. Hace cuatro cosas y ninguna más: carga los tokens de la identidad visual,
 * construye la raíz de React, entrega el control al enrutador y registra el Service Worker.
 *
 * Los tokens se importan aquí y no en cada vista para que el estilo base entre en el paquete
 * inicial: si viajara con el fragmento de la primera ruta, el primer dibujado se vería sin
 * estilo por unos milisegundos.
 *
 * **El Service Worker se registra después de dibujar y sin esperarlo.** Sirve a dos cosas —recibe los
 * recordatorios push del Requisito 25 y es lo que el navegador exige para ofrecer la instalación junto
 * al manifiesto—, y ninguna de las dos justifica retrasar el primer dibujado. Se registra siempre, sin
 * mirar el permiso de notificaciones: el permiso decide si llegan notificaciones, no si la aplicación
 * se puede instalar. Ningún fallo del registro se propaga; ver `lib/serviceWorker.ts`.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { registrarServiceWorker } from './lib/serviceWorker';
import { enrutador } from './router';
import './styles/tokens.css';

const contenedor = document.getElementById('root');

if (contenedor === null) {
  throw new Error('No se encontró el contenedor #root en el documento.');
}

createRoot(contenedor).render(
  <StrictMode>
    <RouterProvider router={enrutador} />
  </StrictMode>,
);

// `void` y no `await`: el registro es una operación de red que no tiene por qué demorar la primera
// pintura, y su resultado no cambia nada de lo que se acaba de dibujar.
void registrarServiceWorker();
